export default {
  // 获取平台列表
  getPlatformList: {
    url: '/platformApi/getPlatformList',
    method: 'POST'
  },
  // 新增平台
  newPlatform: {
    url: '/platformApi/newPlatform',
    method: 'POST'
  },
  // 修改平台
  updatePlatform: {
    url: '/platformApi/updatePlatform',
    method: 'POST'
  },
  // 删除平台
  delPlatform: {
    url: '/platformApi/delPlatform',
    method: 'POST'
  },
  // 恢复平台
  rePlatform: {
    url: '/platformApi/rePlatform',
    method: 'POST'
  },
  // 获取平台信息
  getPlatformInfo: {
    url: '/platformApi/getPlatformInfo',
    method: 'POST'
  },
  // 获取删除平台列表
  getDelPlatformList: {
    url: '/platformApi/getDelPlatformList',
    method: 'POST'
  }
}